/**
 * Admin API helper — automatically injects the Bearer token stored
 * in localStorage.admin_token for every fetch call.
 *
 * Usage:
 *   import { adminFetch } from '../../utils/adminApi';
 *   const res = await adminFetch(`${BACKEND_URL}/api/admin/orders`);
 *   const res = await adminFetch(url, { method: 'PUT', body: JSON.stringify(...) });
 */

export const getAdminToken = () => localStorage.getItem('admin_token') || '';

export const adminFetch = (url, options = {}) => {
  const token = getAdminToken();
  const headers = {
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  return fetch(url, { ...options, headers });
};
